const warnAboutMissing = (name, props, type = "Context") =>
    console.warn(`Missing ${type}: ${name}`, props);

const DEFAULT_ARROWNAVIGATION_CONTEXT = {
    setRows: (...props) => warnAboutMissing(`ArrowNavigation.setRows`, props),
    setCurrentIndex: (...props) =>
        warnAboutMissing(`ArrowNavigation.setCurrentIndex`, props),
    setTarget: (...props) =>
        warnAboutMissing(`ArrowNavigation.setTarget`, props),
};

const DEFAULT_MULTISELECTION = {
    multiple: false,
    activeRows: {},
};

const DEFAULT_TRACK_CURRENT_ROW: TrackCurrentRowProps = {
    currentRow: -1,
    setCurrentRow: (...props) =>
        warnAboutMissing(`TrackCurrentRow.setCurrentRow`, props, "HOC"),
};

export {
    DEFAULT_ARROWNAVIGATION_CONTEXT,
    DEFAULT_MULTISELECTION,
    DEFAULT_TRACK_CURRENT_ROW,
};
